import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { URLQuery } from "@/utils/queryUtils";
import { Button, Card, Input } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import AntIcon from "../../../common/components/icons/AntIcon";
import { AgentDirectorateModalForm } from "../components/forms/AgentDirectorateModalForm";
import { AgentDirectorateTable } from "../components/tables/AgentDirectorateTable";
import { AgentDirectorate } from "../types";

export const AgentDirectorateContainer = () => {
  const { t } = useTranslation();

  const [isOpenModalForm, setIsOpenModalForm] = useState(false);
  const [directorate, setDirectorate] = useState<AgentDirectorate>();

  const navigate = useNavigate();
  const keywordSearchParam = useFilterSearchParams().keyword;

  const handleCancelModalForm = () => {
    setDirectorate(undefined);
    setIsOpenModalForm(false);
  };

  const handleClickAddAgentDirectorate = () => {
    setDirectorate(undefined);
    setIsOpenModalForm(true);
  };

  const handleChangeAgentDirectorate = (directorate: AgentDirectorate) => {
    setDirectorate(directorate);
    setIsOpenModalForm(true);
  };

  const handleSearchSubmit = (value: string) => {
    navigate(
      {
        search: URLQuery.searchParamsToString({ searchParams: { keyword: value }, append: true }),
      },
      { replace: true },
    );
  };

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={<h2>{t("agent.directorates.titles.admin")}</h2>}
        extra={
          <>
            <Button type="primary" icon={<AntIcon type="plus" />} onClick={handleClickAddAgentDirectorate}>
              {t("agent.actions.addAgentDirectorate")}
            </Button>

            <Input.Search
              style={{ width: 350 }}
              enterButton
              allowClear
              placeholder={t("agent.directorates.helpers.searchHint")}
              defaultValue={keywordSearchParam}
              onSearch={handleSearchSubmit}
            />
          </>
        }
      >
        <AgentDirectorateTable onChange={handleChangeAgentDirectorate} />

        <AgentDirectorateModalForm
          isOpen={isOpenModalForm}
          directorate={directorate}
          onCancel={handleCancelModalForm}
        />
      </Card>
    </ContentWrapper>
  );
};
